import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormControlLabel, Grid, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Theme, createStyles, makeStyles } from '@material-ui/core';
import { Field, Form } from 'react-final-form';
import { FormApi, ValidationErrors } from 'final-form';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { checkIfIntialValuesIsEqualToValues } from '../../helpers/commonHelper';
import { StartingStatusSelector } from '../selectors/StartingStatusSelector';
import { PrioritySelector } from '../../tasksSummary/selectors/PrioritySelector';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { TaskTypeGroupAutoCompleteItem, TaskTypeGroupSelector } from '../selectors/TaskTypeGroupSelector';
import { TaskAssignedByUserTeamSelector } from '../../tasksSummary/selectors/TaskAssignedByUserTeamSelector';
import { TimeNumberFormatCustom } from '../../components/TimeNumberFormat';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { mainTheme } from '../../Theme';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            textTransform: 'capitalize',
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        button: {
            margin: theme.spacing(1),
            minWidth: '83px',
        },
        textField: {
            width: '100%',
        },
        assignedToWrapper: {
            display: 'flex',
            alignItems: 'flex-end',
            flexFlow: 'row wrap',
            gap: '10px',
            '& > div': {
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                aliginItems: 'center',
            }
        },
        radioGroup: {
            flexFlow: 'row wrap',
        },
        table: {},
        heading: {
            fontSize: theme.typography.pxToRem(15),
            // fontWeight: theme.typography.fontWeightRegular,
            color: mainTheme.TemplateColor.Primary,
            display: 'flex',
            alignItems: 'center',
        },
    }),
);

interface TaskflowMemberDialogProps extends DialogProps {}

interface TaskflowForm {
    isFormSubmit: boolean;
    description: string | null;
    startingStatus: string | null;
    dueDateType: 'matterDate' | 'taskflowMember';
    estimatedEffort: string | null;
    taskType: TaskTypeGroupAutoCompleteItem | null;
}

export const TaskflowMemberDialog: React.FC<TaskflowMemberDialogProps> = (props) => {
    const classes = useStyles();

    const [showDiscard, setShowDiscard] = React.useState<boolean>(false);

    const [initialValues] = React.useState<TaskflowForm>({
        isFormSubmit: false,
        description: null,
        startingStatus: null,
        dueDateType: 'matterDate',
        estimatedEffort: null,
        taskType: null
    });

    const handleClose = (form: FormApi<TaskflowForm>, values: TaskflowForm) => () => {
        const areValuesEqual = checkIfIntialValuesIsEqualToValues(initialValues, values);

        if (!areValuesEqual) {
            setShowDiscard(true);
        } else {
            if (props.onClose) {
                props.onClose({}, 'backdropClick');
            }
        }
    };

    const onDiscardChanges = (agree: boolean) => {
        if (agree) {
            if (props.onClose) {
                props.onClose({}, 'backdropClick');
            }
        }
        setShowDiscard(false);
    };

    const onSubmit = (values: TaskflowForm, form: FormApi<TaskflowForm, TaskflowForm>) => {
        // tslint:disable-next-line: no-console
        console.log('onSubmit', values);
    };

    const onValdiate = (values: TaskflowForm) => {
        return undefined;
    };

    const onRequired = (value: TaskflowForm) => (value ? undefined : 'Required');

    const onFieldRequiredError = (errors: ValidationErrors, form: FormApi<TaskflowForm>, values: TaskflowForm) => {
        // code here
    };

    const controlButtonComponent = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <div className={classes.buttonContainer}>
                {/* <RenderCount /> */}
                <div>
                    <Button
                        color="primary"
                        type="submit"
                        className={classes.button}
                        onClick={() => {
                            // code here..
                        }}
                        disabled={submitting || pristine}
                    >
                        Save
                    </Button>
                </div>
                <div>
                    <Button color="primary" type="button" className={classes.button} onClick={handleClose(form, values)}>
                        Cancel
                    </Button>
                </div>
            </div>
        );
    };

    const descriptionField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`description`} subscription={{ touched: true, error: true, value: true }} validate={onRequired}>
                {({ input, meta }) => (
                    <TextField
                        {...input}
                        className={classes.textField}
                        error={meta.error && meta.touched}
                        label="Description"
                        required={true}
                        helperText={meta.error && meta.touched ? meta.error : ''}
                    />
                )}
            </Field>
        );
    };

    const assignedToField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`assignedTo`} subscription={{ touched: true, error: true, value: true }}>
                {({ input, meta }) => (
                    <TaskAssignedByUserTeamSelector
                        {...input}
                        label="Assigned To"
                        value={input.value ? input.value : null}
                        disablePortal={false}
                        // required={true}
                        // className={`${classes.textField} ${classes.clientSelector}`}
                        error={meta.error && meta.touched}
                        // tslint:disable-next-line: jsx-alignment
                        onSelection={(selection: IAutoCompleteItem, name: string, isUser: boolean) => {
                            // onDropDownSelect(form, values, input, selection, name, isUser)
                            input.onChange(selection);
                        }}
                        helperText={meta.error && meta.touched ? 'Assigned to is required' : ''}
                        visible={{
                            role: true,
                        }}
                        isAuthorized={true}
                    />
                )}
            </Field>
        );
    };

    const statusField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`status`} subscription={{ touched: true, error: true, value: true }} validate={onRequired}>
                {({ input, meta }) => (
                    <StartingStatusSelector
                        {...input}
                        className={classes.textField}
                        error={meta.error && meta.touched}
                        label="Status"
                        required={true}
                        helperText={meta.error && meta.touched ? meta.error : ''}
                        onSelection={(selection: IAutoCompleteItem) => {
                            input.onChange(selection);
                        }}
                    />
                )}
            </Field>
        );
    };

    const operationFields = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <>
                <Field name="operation" type="radio" value="Add" subscription={{ touched: true, error: true, value: true }}>
                    {({ input, meta }) => (
                        <FormControlLabel
                            {...input}
                            control={<Radio color="primary" />}
                            label="Add"
                        />
                    )}
                </Field>
                <Field name="operation" type="radio" value="Subtract" subscription={{ touched: true, error: true, value: true }}>
                    {({ input, meta }) => (
                        <FormControlLabel
                            {...input}
                            control={<Radio color="primary" />}
                            label="Subtract"
                        />
                    )}
                </Field>
            </>
        );
    };

    const daysField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`days`} subscription={{ touched: true, error: true, value: true }}>
                {({ input, meta }) => (
                    <TextField
                        {...input}
                        className={classes.textField}
                        error={meta.error && meta.touched}
                        label="Days To"
                        // required={true}
                        helperText={meta.error && meta.touched ? meta.error : ''}
                        type="number"
                    />
                )}
            </Field>
        );
    };

    const dueDateTypeField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`dueDateType`} subscription={{ touched: true, error: true, value: true }}>
                {({ input, meta }) => (
                    <RadioGroup 
                        {...input}
                        className={classes.radioGroup}
                    >
                        <FormControlLabel value="matterDate" control={<Radio color="primary" />} label="Matter Date" />
                        <FormControlLabel value="taskflowMember" control={<Radio color="primary" />} label="Taskflow Member" />
                    </RadioGroup>
                )}
            </Field>
        );
    };

    const dateOrMemberField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {

        if (values.dueDateType === 'matterDate') {
            return (
                <Field name={`assignedTo`} subscription={{ touched: true, error: true, value: true }}>
                    {({ input, meta }) => (
                        <StartingStatusSelector
                            {...input}
                            className={classes.textField}
                            error={meta.error && meta.touched}
                            label="Select Date"
                            // required={true}
                            helperText={meta.error && meta.touched ? meta.error : ''}
                            onSelection={(selection: IAutoCompleteItem) => {
                                input.onChange(selection);
                            }}
                        />
                    )}
                </Field>
            );
        }

        return (
            <Field name={`assignedTo`} subscription={{ touched: true, error: true, value: true }}>
                {({ input, meta }) => (
                    <StartingStatusSelector
                        {...input}
                        className={classes.textField}
                        error={meta.error && meta.touched}
                        label="Select Member"
                        // required={true}
                        helperText={meta.error && meta.touched ? meta.error : ''}
                        onSelection={(selection: IAutoCompleteItem) => {
                            input.onChange(selection);
                        }}
                    />
                )}
            </Field>
        );
    };

    const taskTypeField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`taskType`} subscription={{ touched: true, error: true, value: true }}>
                {({ input, meta }) => (
                    <TaskTypeGroupSelector
                        {...input}
                        label="Task Type"
                        name="taskType"
                        // tslint:disable-next-line: no-any
                        onSelection={(selection: TaskTypeGroupAutoCompleteItem | undefined | any, name: string) => {
                            input.onChange(selection);
                            form.change('estimatedEffort', selection ? selection.estimatedEffort : null);
                        }}
                    />
                )}
            </Field>
        );
    };

    const priorityField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`priority`} subscription={{ touched: true, error: true, value: true }}>
                {({ input, meta }) => (
                    <PrioritySelector
                        {...input}
                        className={classes.textField}
                        error={meta.error && meta.touched}
                        label="Priority"
                        // required={true}
                        helperText={meta.error && meta.touched ? meta.error : ''}
                        onSelection={(selection: IAutoCompleteItem) => {
                            input.onChange(selection);
                        }}
                    />
                )}
            </Field>
        );
    };

    const estimatedEffortField = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Field name={`estimatedEffort`} subscription={{ touched: true, error: true, value: true }}>
                {({ input, meta }) => (
                    <TextField
                        {...input}
                        label="Estimated Effort"
                        name="estimatedEffort"
                        InputProps={{
                            // tslint:disable-next-line: no-any
                            inputComponent: TimeNumberFormatCustom as any,
                        }}
                        className={classes.textField}
                        error={meta.error && meta.touched}
                        helperText={meta.error && meta.touched ? 'Estiamted Effort is required' : ''}
                        placeholder="00:00"
                    />
                )}
            </Field>
        );
    };

    const dueDatesFields = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Accordion
                defaultExpanded={true}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                <Typography className={classes.heading}>Due Dates</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container={true} spacing={1}>
                        <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                            {operationFields(form, submitting, pristine, values)}
                        </Grid>
                        <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                            {daysField(form, submitting, pristine, values)}
                        </Grid>
                        <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                           {dueDateTypeField(form, submitting, pristine, values)}
                        </Grid>
                        <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                            {dateOrMemberField(form, submitting, pristine, values)}
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        );
    };

    const onComplemetionTable = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Accordion
                defaultExpanded={true}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                <Typography className={classes.heading}>On Completion</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                            <TableRow>
                                <TableCell>Set Taskflow Member</TableCell>
                                <TableCell>To Status</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Member 1</TableCell>
                                    <TableCell>Starting</TableCell>
                                </TableRow>
                                {/* {rows.map((row) => (
                                    <TableRow key={row.name}>
                                        <TableCell>{row.calories}</TableCell>
                                        <TableCell>{row.fat}</TableCell>
                                    </TableRow>
                                ))} */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>
        );
    };

    const standarFields = (form: FormApi<TaskflowForm>, submitting: boolean, pristine: boolean, values: TaskflowForm) => {
        return (
            <Grid container={true} spacing={1}>
                <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                    {descriptionField(form, submitting, pristine, values)}
                </Grid>
                <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                    {statusField(form, submitting, pristine, values)}
                </Grid>
                <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                    {assignedToField(form, submitting, pristine, values)}
                </Grid>
                <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                    {dueDatesFields(form, submitting, pristine, values)}
                </Grid>
                <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                    {taskTypeField(form, submitting, pristine, values)}
                </Grid>
                <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                    {priorityField(form, submitting, pristine, values)}
                </Grid>
                <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                    <Grid container={true} spacing={1}>
                        <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                            {estimatedEffortField(form, submitting, pristine, values)}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                    {onComplemetionTable(form, submitting, pristine, values)}
                </Grid>
            </Grid>
        );
    };

    return (
        <>
            <DialogBox
                title="Task Type"
                // tslint:disable-next-line:max-line-length
                content={`Are you sure you want to close the form?`}
                show={showDiscard}
                isAgree={onDiscardChanges}
                disAgreeLabel={'No'}
                agreeLabel={'Yes'}
            />

            <Form
                onSubmit={onSubmit}
                // mutators={{ ...arrayMutators }}
                initialValues={initialValues}
                validate={onValdiate}
                keepDirtyOnReinitialize={true}
                initialValuesEqual={() => true}
                subscription={{ submitting: true, pristine: true, values: true }}
                // debug={(values) => {
                //     // tslint:disable-next-line: no-console
                //     console.log('Debug Values', values);
                // }}
                render={({ errors, handleSubmit, form, submitting, pristine, values }) => {
                    if (values.isFormSubmit) {
                        onFieldRequiredError(errors, form, values);
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Dialog {...props} onClose={handleClose(form, values)}>
                                <DialogTitle className={classes.header}>Taskflow Member</DialogTitle>
                                <DialogContent>{standarFields(form, submitting, pristine, values)}</DialogContent>
                                <DialogActions>{controlButtonComponent(form, submitting, pristine, values)}</DialogActions>
                            </Dialog>
                        </form>
                    );
                }}
            />
        </>
    );
};